module.exports = flarum.core.compat['forum/states/PostStreamState'];